import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, CheckCircle } from 'lucide-react';
import { usePopup } from '../context/PopupContext';

const HeroSection = () => {
  const { openPopup } = usePopup();

  return (
    <section
      className="hero-section relative min-h-screen flex items-center pt-20 overflow-hidden w-full bg-[#1a0508] bg-cover bg-center bg-no-repeat"
      style={{ backgroundImage: "url('/assets/img/hero-bg.png')" }}
    >
      <div className="container mx-auto px-4 py-20 relative z-10 max-w-[1320px]">
        <div className="flex flex-col items-center text-center max-w-4xl mx-auto">
          <span className="border border-white/70 text-white px-4 py-1.5 rounded-md text-xs sm:text-sm font-medium mb-8">
            Protecting 10,000+ Brands Nationwide
          </span>

          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-tight">
            Safeguard Your Brand with
            <span className="block text-[#C0392B]">Expert Trademark Protection</span>
          </h1>

          <p className="text-base sm:text-lg text-white/90 leading-relaxed max-w-3xl mt-6">
            Secure your business identity with professional trademark registration services from just $45.
            Get USPTO-certified filing, attorney-reviewed applications, and complete peace of mind.
          </p>

          <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-3 mt-8 max-w-2xl">
            {[
              '98% Approval Success Rate',
              'Expert Legal Review & Support',
              'Official USPTO Filing & Registration'
            ].map((feature, index) => (
              <div key={index} className="flex items-center space-x-2 text-white">
                <CheckCircle className="w-5 h-5 text-[#C0392B] flex-shrink-0" />
                <span className="font-medium">{feature}</span>
              </div>
            ))}
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mt-8">
            <div className="flex items-center gap-2">
              <Button
                onClick={openPopup}
                className="bg-[#C0392B] hover:bg-[#A93226] text-white px-6 py-5 text-sm font-semibold rounded-md"
              >
                Start Your Registration - $45
              </Button>
              <button
                type="button"
                aria-label="Start your registration"
                onClick={openPopup}
                className="bg-[#C0392B] hover:bg-[#A93226] text-white w-10 h-10 rounded-md flex items-center justify-center"
              >
                <ArrowRight className="w-4 h-4 -rotate-45" />
              </button>
            </div>

            <Button
              variant="outline"
              onClick={() => window.openTawkTrikChat && window.openTawkTrikChat()}
              className="bg-transparent border border-white text-white hover:bg-white hover:text-[#2C3E50] px-6 py-5 text-sm font-semibold rounded-md"
            >
              Chat Now
            </Button>
          </div>

          <div className="flex items-start justify-center gap-8 sm:gap-24 mt-12">
            {[
              ['10K+', 'Trademarks'],
              ['98%', 'Success Rate'],
              ['15+', 'Years']
            ].map(([value, label]) => (
              <div key={label} className="text-center">
                <div
                  className="text-5xl sm:text-7xl font-bold leading-none tracking-tight text-transparent bg-clip-text bg-gradient-to-b from-white via-white/60 to-white/25"
                  style={{ WebkitTextFillColor: 'transparent' }}
                >
                  {value}
                </div>
                <div className="text-sm sm:text-base text-white mt-3">{label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
    // <section className="hero-section relative min-h-screen flex items-center pt-20 overflow-hidden w-full">
    //   <div className="absolute inset-0 bg-gradient-to-br from-[#FDFEFE] via-[#FDFEFE] to-[#FEF5F5] z-0" />
      
    //   <div className="absolute top-20 right-0 w-72 h-72 bg-[#C0392B]/5 rounded-full blur-3xl" />
    //   <div className="absolute bottom-20 left-0 w-96 h-96 bg-[#7F8C8D]/5 rounded-full blur-3xl" />

    //   <div className="container mx-auto px-4 py-20 relative z-10 max-w-[1320px]">
    //     <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
    //       <div className="space-y-8">
    //         <div className="inline-block">
    //           <span className="bg-[#C0392B]/10 text-[#C0392B] px-4 py-2 rounded-full text-sm font-semibold">
    //             Protecting 10,000+ Brands Nationwide
    //           </span>
    //         </div>

    //         <div className="space-y-4">
    //           <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-[#2C3E50] leading-tight">
    //             Safeguard Your Brand with
    //             <span className="text-[#C0392B]"> Expert Trademark Protection</span>
    //           </h1>
              
    //           <p className="text-xl text-[#7F8C8D] leading-relaxed max-w-2xl">
    //             Secure your business identity with professional trademark registration services from just $45. 
    //             Get USPTO-certified filing, attorney-reviewed applications, and complete peace of mind.
    //           </p>
    //         </div>

    //         <div className="space-y-3">
    //           {[
    //             'Official USPTO Filing & Registration',
    //             'Expert Legal Review & Support',
    //             '98% Approval Success Rate'
    //           ].map((feature, index) => (
    //             <div key={index} className="flex items-center space-x-3 group">
    //               <CheckCircle className="w-6 h-6 text-[#C0392B] flex-shrink-0 transition-transform duration-300 group-hover:scale-125 group-hover:rotate-12" />
    //               <span className="text-[#2C3E50] font-medium transition-colors duration-300 group-hover:text-[#C0392B]">{feature}</span>
    //             </div>
    //           ))}
    //         </div>

    //         <div className="flex flex-col sm:flex-row gap-4 pt-4">
    //           <Button
    //             onClick={openPopup}
    //             className="bg-[#C0392B] hover:bg-[#A93226] text-white px-8 py-6 text-lg font-semibold transition-all duration-300 hover:shadow-xl btn-glow-hover group"
    //           >
    //             Start Your Registration - $45
    //             <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-2 transition-all duration-300" />
    //           </Button>
              
    //           <Button
    //             variant="outline"
    //             onClick={() => window.openTawkTrikChat && window.openTawkTrikChat()}
    //             className="border-2 border-[#C0392B] text-[#C0392B] hover:bg-[#C0392B] hover:text-white px-8 py-6 text-lg font-semibold transition-all duration-300 btn-glow-hover"
    //           >
    //             Chat Now
    //           </Button>
    //         </div>

    //         <div className="flex items-center space-x-6 pt-6">
    //           <div className="text-center">
    //             <div className="text-3xl font-bold text-[#C0392B]">10K+</div>
    //             <div className="text-sm text-[#7F8C8D]">Trademarks</div>
    //           </div>
    //           <div className="h-12 w-px bg-[#7F8C8D]/30" />
    //           <div className="text-center">
    //             <div className="text-3xl font-bold text-[#C0392B]">98%</div>
    //             <div className="text-sm text-[#7F8C8D]">Success Rate</div>
    //           </div>
    //           <div className="h-12 w-px bg-[#7F8C8D]/30" />
    //           <div className="text-center">
    //             <div className="text-3xl font-bold text-[#C0392B]">15+</div>
    //             <div className="text-sm text-[#7F8C8D]">Years</div>
    //           </div>
    //         </div>
    //       </div>

    //       <div className="relative">
    //         <div className="relative rounded-2xl overflow-hidden shadow-2xl image-hover-zoom image-overlay h-[600px]">
    //           <img
    //             src="/assets/img/hero-professional-services.webp"
    //             alt="Professional trademark registration services"
    //             className="w-full h-full object-cover"
    //             fetchPriority="high"
    //           />
              
    //           <div className="absolute bottom-8 left-8 right-8 bg-white rounded-xl p-6 shadow-xl backdrop-blur-sm bg-white/95 z-10 card-lift">
    //             <div className="flex items-center justify-between">
    //               <div>
    //                 <p className="text-sm text-[#7F8C8D] mb-1">Starting at Only</p>
    //                 <p className="text-2xl font-bold text-[#C0392B]">$45</p>
    //               </div>
    //               <div className="text-right">
    //                 <p className="text-sm text-[#7F8C8D] mb-1">Complete Trademark Filing</p>
    //                 <p className="text-sm font-semibold text-[#2C3E50]">Get Started Today</p>
    //               </div>
    //             </div>
    //           </div>
    //         </div>

    //         <div className="absolute -top-4 -right-4 bg-[#C0392B] text-white rounded-full w-24 h-24 flex items-center justify-center shadow-lg transform rotate-12 icon-pulse">
    //           <div className="text-center">
    //             <div className="text-sm font-bold">Fast</div>
    //             <div className="text-xs">Filing</div>
    //           </div>
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    // </section>
  );
};

export default HeroSection;